import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * ご利用明細の一覧
 *
 * ご利用明細データの一覧を返す
 */
export class FetchPayment implements APIRequest<Monitaro.FetchPaymentResponse> {
  response: Monitaro.FetchPaymentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/payments`
  }
}

/**
 * 未払い状況取得
 *
 * 自分が未払だったときはtrueが返ってくる
 */
export class GetCheckPayment implements APIRequest<Monitaro.GetCheckPaymentResponse> {
  response: Monitaro.GetCheckPaymentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor() {
    this.path = `/payments/check`
  }
}
